import { Component } from '@angular/core';
import { ChartDataset } from 'chart.js';
import { GRAPH_PANEL_IMPORTS, GraphPanelComponent } from 'src/app/panels/components/graph-panel/graph-panel.component';
import { PanelComponent } from 'src/app/panels/components/panel.component';
import { DisplayUnit } from 'src/app/panels/models/display-unit';
import { GenerateGraphDataset, GraphType, IGraphConfig, IGraphMappedDataset } from 'src/app/panels/models/graph';
import { PanelType } from 'src/app/panels/models/panel-type';
import { Color } from 'src/app/shared/services/color/colors';

@PanelComponent.register
@Component({
  templateUrl: '../../../../panels/components/graph-panel/graph-panel.component.html',
  styleUrl: '../../../../panels/components/graph-panel/graph-panel.component.scss',
  selector: 'app-kwh-m2-graph-panel',
  imports: GRAPH_PANEL_IMPORTS,
})
export class KwhPerM2GraphPanelComponent extends GraphPanelComponent {
  public static override readonly type = PanelType.KwhPerM2Graph;
  public override unit = DisplayUnit.Kwh;

  public override config: IGraphConfig = {
    sortOrder: [GraphType.EnvironmentElectricityPerSquareMeter, GraphType.EnvironmentGasPerSquareMeter],
    legendSortOrder: [GraphType.EnvironmentElectricityPerSquareMeter, GraphType.EnvironmentGasPerSquareMeter],
    annotationsInFront: true,
    getGraphTypeDataset: this.getGraphTypeDataset,
  };

  protected override graphInfo = {
    title: `${DisplayUnit.KwhSquareMeter} grafiek`,
    description: `
       <p>
         In deze grafiek zie je het energieverbruik uitgedrukt in ${DisplayUnit.Kwh} per vierkante meter per maand (${DisplayUnit.KwhSquareMeter}). Dit geeft inzicht in hoe energie-efficiënt een gebouw presteert in verhouding tot de gebouwgrootte.
       </p>
       <p>
         De referentielijn in de grafiek is gebaseerd op de ingestelde gebruiksfunctie en het gebruikstype van het gebouw. Voor ieder gebouwtype gelden namelijk andere richtwaarden voor energiegebruik volgens de WEii / Paris Proof-methodiek. Hierdoor wordt een kantoor bijvoorbeeld beoordeeld op andere grenswaarden dan een zwembad, hotel of winkel.
       </p>
       <p>
         De getoonde doellijn vertegenwoordigt de Paris Proof-richtwaarde omgerekend naar een maandgemiddelde (jaarwaarde ÷ 12). Zo ontstaat een eerlijke vergelijking die aansluit bij het daadwerkelijke type gebouw en het verwachte energiegebruik daarvan.
       </p>
     `,
  };

  private getGraphTypeDataset(
    generateDataset: GenerateGraphDataset,
    dataset: IGraphMappedDataset,
    startTimestamps: string[],
    endTimestamps: string[],
  ): ChartDataset {
    switch (dataset.type) {
      case GraphType.EnvironmentElectricityPerSquareMeter:
        return generateDataset(
          dataset,
          startTimestamps,
          endTimestamps,
          'Electriciteit',
          Color.BrightBlue,
          DisplayUnit.KwhSquareMeter,
          'bar',
        );
      case GraphType.EnvironmentGasPerSquareMeter:
        return generateDataset(
          dataset,
          startTimestamps,
          endTimestamps,
          'Gas',
          Color.LightBlue,
          DisplayUnit.KwhSquareMeter,
          'bar',
        );
      default:
        throw new Error(`No dataset specified for GraphType '${dataset.type}'`);
    }
  }
}
